import { useUpdateEffect } from 'genesis-suite/hooks'
import produce from 'immer'
import { useContext, useEffect, useState } from 'react'
import { filterService } from '../../lib/services'
import { CloudContext } from '../contexts/CloudContext'
import NetworkSelector from './NetworkSelector'

const NetworkFilterController = ({ defaultRows, onChange, selected }) => {
    const [rows, setRows] = useState(defaultRows)
    const [networkOptions, setNetworkOptions] = useState([])
    const { selectedCloud } = useContext(CloudContext)

    useUpdateEffect(() => {
        onChange(rows)
    }, [rows])

    useEffect(() => {
        async function getNetworks() {
            try {
                const networkF = await filterService.getNetworkFilters(selectedCloud)
                if (networkF) {
                    setNetworkOptions(networkF.map(x => ({ label: x.name, value: x.id })))
                }
            } catch (e) {
                console.error(e)
            }
        }

        getNetworks()
    }, [])

    const handleChange = (val, id, defaultNode) => {
        setRows(
            produce(rows, draft => {
                draft = draft.map(row => {
                    if (row.id === id) {
                        row.role = val
                        row.defaultNode = defaultNode
                    }
                    return row
                })
            })
        )
    }

    return (
        <>
            {rows &&
                rows.map(row => (
                    <NetworkSelector
                        id={row.id}
                        key={row.id}
                        onChange={handleChange}
                        application={selectedCloud}
                        options={networkOptions}
                        selected={selected}
                    />
                ))}
        </>
    )
}

export default NetworkFilterController
